import React, { useState, useEffect, useRef } from "react";
import { Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import "./CountDropDown.css";

const CountDropDown = ({ value = [], options = [], onChange }) => {
  const [selectedValues, setSelectedValues] = useState(value);
  const selectRef = useRef(null);

  useEffect(() => {
    setSelectedValues(value);
  }, [value]);

  const handleChange = (event) => {
    const selected = event.target.value;

    if (selected.includes("check_all")) {
      setSelectedValues(options.map((opt) => opt.id));
      onChange(options.map((opt) => opt.id));
    } else if (selected.includes("uncheck_all")) {
      setSelectedValues([]);
      onChange([]);
    } else {
      setSelectedValues(selected);
      onChange(selected);
    }
  };

  return (
    <div ref={selectRef}>
      <Select
        multiple
        displayEmpty
        value={selectedValues}
        onChange={handleChange}
        renderValue={(selected) =>
          selected.length === 0 ? "SELECT ENTITY" : `${selected.length} CHECKED`
        }
        sx={{
          width: "100%",
          maxHeight: "38px",
          color: "#212129", // Ensures text color inside the Select box
          "& .MuiSelect-select": {
            color: "#212129 !important", // Forces text color inside the select dropdown
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 200, // Set max height for scrollability
              overflowY: "auto",
              marginTop: 8, // Ensures it appears below the select
            },
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        <MenuItem value="check_all">
          <Checkbox checked={selectedValues.length === options.length} />
          <ListItemText primary="✔ Check All" />
        </MenuItem>
        <MenuItem value="uncheck_all">
          <Checkbox checked={selectedValues.length === 0} />
          <ListItemText primary="✖ Uncheck All" />
        </MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            <Checkbox checked={selectedValues.includes(opt.id)} />
            <ListItemText primary={opt.Label} />
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default CountDropDown;
